$(function () {
  $(document).on('change', '.custom-file-input', function () {
      const input = $(this);
      const label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [label]);
  });

  $('.custom-file-input').on('fileselect', function (event, label) {
      $(this).parents('li.file').find('label').text(label);
  });

  $('article.blog.post img').addClass('img-fluid');
  $('table').addClass('table');

  return true;
});
